import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';

interface ErrorScreenProps {
    error: any;
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({ error }) => {
    const handleReload = () => window.location.reload();

    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh" sx={{ bgcolor: 'background.default', px: 2 }}>
            <Paper
                elevation={3}
                sx={{
                    maxWidth: 500,
                    width: '100%',
                    p: 4,
                    textAlign: 'center',
                    bgcolor: '#fce4ec',
                    borderRadius: 3
                }}
            >
                <Typography variant="h5" fontWeight={600} gutterBottom>
                    Oops, something went wrong.
                </Typography>

                <Typography variant="body1" color="text.secondary" mb={2}>
                    We can't process your request right now.
                </Typography>

                <Typography variant="body2" color="error.main">
                    {process.env.NODE_ENV === 'development' ? error?.message || 'Unknown error' : 'Something went wrong. Please try again later.'}
                </Typography>

                <Button variant="contained" color="error" onClick={handleReload} sx={{ textTransform: 'none' }}>
                    Reload Page
                </Button>
            </Paper>
        </Box>
    );
};
